import React from 'react';

const Header = () => {
  return (
    <div>
      <div className="brand">El Capullo</div>
      <div className="address-bar">| 18 de Julio 219 | Barrio histórico | Colonia del Sacramento | Uruguay |</div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js